import styled from 'styled-components';

const PricingSectionWrapper = styled.section`
    padding: 90px 0 108px 0;
    overflow: hidden;
    position: relative;
    .section__particle{
        position: absolute;
        &.one{
            width: 190px;
            left: -5%;
            bottom: 0px;
        }
        &.two{
            width: 144px;
            top: 27%;
            right: -4%;
        }
    }
    .pricing-block{
        padding:  0px; // 60px 55px 60px;
        border: 1px solid ${props => props.theme.primaryLightColor};
        box-shadow: 0 0 40px ${props => props.theme.shadowColor};
        border-radius: 5px;
        position: relative;
        text-align: center;
        transition: all 0.3s ease-in;
        p {
            padding: 20px 40px 20px 40px;
            font-size: 20px;
        }
        &:hover{
            border-color: ${props => props.theme.colors.primaryColor};
            .thumb-block{
                border-color: ${props => props.theme.colors.primaryColor};
                
            }
            .pricing-btn{
                opacity: 1;
            }
        }
    }
    .thumb-block{
        padding-bottom: 0px;
        border-bottom: 1px solid rgba(112,112,112,0.3);
        transition: all 0.3s ease-in;
        background-color:#159D8F;

        display: flex;
        align-items: center;
        justify-content: center;

        img {
            padding: 50px;
        }
    }
    .price-block{
        text-align: center;
        padding: 40px 0 23px 0;
        h1{
            font-size: 50px;
            font-weight: 600;
            margin: 0 0 10px 0; 
            color: ${props => props.theme.colors.white};
            font-weight: 700;
        }
        p{
            font-size: 18px;
            margin-bottom: 0;
            color: ${props => props.theme.colors.grey};
        }
    }
    .price-block ~ p{
        margin-top: 0;
        margin-bottom: 22px;
        text-align: center;

    }
    .details-block{
        text-align: left;
        span{
            color: ${props => props.theme.headingColor};
            font-weight: 300;
            display: flex;
            align-items: center;
            svg{
                fill: ${props => props.theme.textColor};
                margin-right: 20px;
            }
        }
        .off{
            svg{
                fill: ${props => props.theme.secondaryColor};
            }
        }
        span+span{
            margin-top: 2px;
        }
    }
    .pricing-btn{
        font-size: 25px;
        font-family: 'Barlow';
        font-weight: 700;
        color: #fff;
        padding: 15px 20px;
        margin: 0 auto;
        position: absolute;
        text-align: center;
        bottom: -30px;
        left: 0;
        right: 0;
        opacity: 1;
        transition: all 0.3s ease-in;
        background: #DD961C; //rgb(251,123,129);
        background: -moz-linear-gradient(left,  rgba(221,150,28,1) 0%, rgba(255,184,62,1) 100%);
        background: -webkit-linear-gradient(left,  rgba(221,150,28,1) 0%,rgba(255,184,62,1) 100%);
        background: linear-gradient(to right,  rgba(221,150,28,1) 0%,rgba(255,184,62,1) 100%);
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#DD961C', endColorstr='#FFB83E',GradientType=1 );

    }
    @media only screen and (max-width: 1280px) {
        padding: 90px 0 210px 0;
        
        .pricing-block{
            padding: 40px 15px 35px 15px;
        }
        .section__particle{
            &.one{
                bottom: 0px;
            }
            &.two{
                display: none;
            }
        }
    }
    @media only screen and (max-width: 912px) {
        padding: 0;
        .section__particle{
            &.one {
                bottom: -122px;
            }
        }
        .pricing-block p {
            padding: 20px;
        }
        .price-block{
            margin: 10px 0px 10px 0px;
            padding: 0px;

            p {
                padding: 10px 0px 10px 0px;
            }
        }

        .thumb-block{
            padding-bottom: 0px;
            flex-direction: column;

            img {
                padding: 20px 0px 10px 0px;
            }
        }
    }
    @media only screen and (max-width: 480px) {
        .pricing-block{
            margin: 0px 10px 0px 10px;
            padding: 0px;
        }
    }
    
    
`

export default PricingSectionWrapper;